// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpressSetupPlanDto } from './IExpressSetupPlanDto';
import {
    IExpressSetupPlanDtoFromJSON,
    IExpressSetupPlanDtoFromJSONTyped,
    IExpressSetupPlanDtoToJSON,
    IExpressSetupPlanDtoToJSONTyped,
} from './IExpressSetupPlanDto';
import type { IExpressSetupAddressDto } from './IExpressSetupAddressDto';
import {
    IExpressSetupAddressDtoFromJSON,
    IExpressSetupAddressDtoFromJSONTyped,
    IExpressSetupAddressDtoToJSON,
    IExpressSetupAddressDtoToJSONTyped,
} from './IExpressSetupAddressDto';
import type { IExpressSetupPlanYearDto } from './IExpressSetupPlanYearDto';
import {
    IExpressSetupPlanYearDtoFromJSON,
    IExpressSetupPlanYearDtoFromJSONTyped,
    IExpressSetupPlanYearDtoToJSON,
    IExpressSetupPlanYearDtoToJSONTyped,
} from './IExpressSetupPlanYearDto';
import type { IExpressSetupHealthPlanDto } from './IExpressSetupHealthPlanDto';
import {
    IExpressSetupHealthPlanDtoFromJSON,
    IExpressSetupHealthPlanDtoFromJSONTyped,
    IExpressSetupHealthPlanDtoToJSON,
    IExpressSetupHealthPlanDtoToJSONTyped,
} from './IExpressSetupHealthPlanDto';
import type { IExpressSetupCopayDto } from './IExpressSetupCopayDto';
import {
    IExpressSetupCopayDtoFromJSON,
    IExpressSetupCopayDtoFromJSONTyped,
    IExpressSetupCopayDtoToJSON,
    IExpressSetupCopayDtoToJSONTyped,
} from './IExpressSetupCopayDto';
import type { IExpressSetupAccountDto } from './IExpressSetupAccountDto';
import {
    IExpressSetupAccountDtoFromJSON,
    IExpressSetupAccountDtoFromJSONTyped,
    IExpressSetupAccountDtoToJSON,
    IExpressSetupAccountDtoToJSONTyped,
} from './IExpressSetupAccountDto';

/**
 * 
 * @export
 * @interface IExpressSetupJson
 */
export interface IExpressSetupJson {
    /**
     * 
     * @type {IExpressSetupAccountDto}
     * @memberof IExpressSetupJson
     */
    account?: IExpressSetupAccountDto;
    /**
     * 
     * @type {IExpressSetupPlanYearDto}
     * @memberof IExpressSetupJson
     */
    plan_year?: IExpressSetupPlanYearDto;
    /**
     * 
     * @type {Array<IExpressSetupPlanDto>}
     * @memberof IExpressSetupJson
     */
    plans?: Array<IExpressSetupPlanDto>;
    /**
     * 
     * @type {IExpressSetupHealthPlanDto}
     * @memberof IExpressSetupJson
     */
    health_plan?: IExpressSetupHealthPlanDto;
    /**
     * 
     * @type {Array<IExpressSetupCopayDto>}
     * @memberof IExpressSetupJson
     */
    copays?: Array<IExpressSetupCopayDto>;
    /**
     * 
     * @type {IExpressSetupAddressDto}
     * @memberof IExpressSetupJson
     */
    address?: IExpressSetupAddressDto;
}

/**
 * Check if a given object implements the IExpressSetupJson interface.
 */
export function instanceOfIExpressSetupJson(value: object): value is IExpressSetupJson {
    return true;
}

export function IExpressSetupJsonFromJSON(json: any): IExpressSetupJson {
    return IExpressSetupJsonFromJSONTyped(json, false);
}

export function IExpressSetupJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupJson {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : IExpressSetupAccountDtoFromJSON(json['account']),
        'plan_year': json['plan_year'] == null ? undefined : IExpressSetupPlanYearDtoFromJSON(json['plan_year']),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IExpressSetupPlanDtoFromJSON)),
        'health_plan': json['health_plan'] == null ? undefined : IExpressSetupHealthPlanDtoFromJSON(json['health_plan']),
        'copays': json['copays'] == null ? undefined : ((json['copays'] as Array<any>).map(IExpressSetupCopayDtoFromJSON)),
        'address': json['address'] == null ? undefined : IExpressSetupAddressDtoFromJSON(json['address']),
    };
}

export function IExpressSetupJsonToJSON(json: any): IExpressSetupJson {
    return IExpressSetupJsonToJSONTyped(json, false);
}

export function IExpressSetupJsonToJSONTyped(value?: IExpressSetupJson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': IExpressSetupAccountDtoToJSON(value['account']),
        'plan_year': IExpressSetupPlanYearDtoToJSON(value['plan_year']),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IExpressSetupPlanDtoToJSON)),
        'health_plan': IExpressSetupHealthPlanDtoToJSON(value['health_plan']),
        'copays': value['copays'] == null ? undefined : ((value['copays'] as Array<any>).map(IExpressSetupCopayDtoToJSON)),
        'address': IExpressSetupAddressDtoToJSON(value['address']),
    };
}

